import { useEffect, useRef } from 'react';
import { processarTranscricaoIACEA } from '../../../../../services/TranscricaoBeneficiarioService';
import { useTranscricao } from '../context';

interface UseProcessarIaceaOptions {
  onError?: (title: string, message: string) => void;
}

export const useProcessarIacea = ({ onError }: UseProcessarIaceaOptions = {}) => {
  const { state, dispatch } = useTranscricao();
  const disparouRef = useRef(false);
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    const { idTranscricao, origemRevisao } = state;

    if (origemRevisao !== 'aposSalvar' || !idTranscricao) {
      return;
    }

    if (disparouRef.current) {
      return;
    }

    disparouRef.current = true;
    dispatch({ type: 'SET_ORIGEM_REVISAO', payload: 'continuarRascunho' });

    void (async () => {
      const resultado = await processarTranscricaoIACEA({ idTranscricao });
      if (resultado.ok) {
        return;
      }

      dispatch({ type: 'SET_REVISAO_STATUS', payload: 'erro' });
      onErrorRef.current?.(
        'Erro ao processar transcrição',
        resultado.message,
      );
    })();
  }, [dispatch, state.idTranscricao, state.origemRevisao]);
};
